const CATEGORY_SECTION_DATA_ATTR = "data-category-id";

export const getCategorySectionDataProps = (categoryId: string) => ({
    [CATEGORY_SECTION_DATA_ATTR]: categoryId,
});

export const getCategorySectionSelector = (categoryId: string) => `[${CATEGORY_SECTION_DATA_ATTR}="${categoryId}"]`;
